import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";
import { objectToQuery } from "../../ObjectToQuery";

export enum TimeScope {
    DAY= 'day',
    WEEK= 'week',
    MONTH= 'month',
    YEAR= 'year'
}

const scopeToDay  = {
    'day': 1,
    'week': 7,
    'month': 30,
    'year': 365
}

export class GetInstanceStatsIncomeResponse {
    income: number;
    growth: number;
}

export function getInstanceStatsIncome(instance_id: number, time_scope: TimeScope, time_scale: number, page = 1): Promise<AxiosResponse<GetInstanceStatsIncomeResponse>>{
    const days = scopeToDay[time_scope]*time_scale;
    return Cirus.get(`/instance/${instance_id}/stats/income?days=${days}&page=${page}`);
}
// `time_scope=${this.period[0]}&time_scale=${this.period[1]}`


// getDailyTransactions(instance_id) {
	// 	return Cirus.get(`/instance/${instance_id}/report/daily-trans`);
	// }